import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // DataTable ID
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
                            columns: [
                                // Column definitions
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    fillspace: 0, // Fill space setting
                                    minWidth: 0, // Minimum width
                                    width: 200, // Fixed width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'Hour', // Column ID for the hour
                                    header: _('Hora'), // Column header with localization for "Hour"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'NoTicket', // Column ID for the ticket number
                                    header: _('No. Ticket'), // Column header with localization for "No. Ticket"
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'FormaPago1', // Column ID for the first payment method
                                    header: _('Forma Pago 1'), // Column header with localization for "Payment Method 1"
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'PagoBonoTC', // Column ID for the bonus payment or credit card
                                    header: _('Pago Bono / T.C.'), // Column header with localization for "Bonus Payment / Credit Card"
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorEntradasEfectivo', // Column ID for cash entries value
                                    header: _('Valor Entradas Efectivo'), // Column header with localization for "Cash Entries Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorEntradasBonoTC', // Column ID for bonus or credit card entries value
                                    header: _('Valor Entradas Bono / T.C.'), // Column header with localization for "Bonus / Credit Card Entries Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorEntradasTraslados', // Column ID for transfer entries value
                                    header: _('Valor Entradas Traslados'), // Column header with localization for "Transfer Entries Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorEntradasRecargas', // Column ID for recharge entries value
                                    header: _('Valor Entradas Recargas'), // Column header with localization for "Recharge Entries Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorEntradasRecargasAgentes', // Column ID for agent recharge entries value
                                    header: _('Valor Entradas Recargas Agentes'), // Column header with localization for "Agent Recharge Entries Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorSalidasEfectivo', // Column ID for cash outflows value
                                    header: _('Valor Salidas Efectivo'), // Column header with localization for "Cash Outflows Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorSalidasTraslados', // Column ID for transfer outflows value
                                    header: _('Valor Salidas Traslados'), // Column header with localization for "Transfer Outflows Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'ValorSalidasNotasRetiro', // Column ID for withdrawal notes value
                                    header: _('Valor Salidas Notas de Retiro'), // Column header with localization for "Withdrawal Notes Value"
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'Saldo', // Column ID for balance
                                    header: _('Saldo'), // Column header with localization for "Balance"
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                                {
                                    id: 'Moneda', // Column ID for currency
                                    header: _('Moneda'), // Column header with localization for "Currency"
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type as integer
                                },
                            ],
                            footer: true, // Enable footer
                            math: true, // Enable mathematical operations in footer
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                            pager: 'pagerA', // Pager ID
                            leftSplit: screen.width > 500 && screen.height > 500 ? 1 : 0, // Conditional left split
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get DataTable instance
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = devConfig.geturlApi() + 'es/Financial/GetFlujoCaja?FromId=' + cur_user + '&'; // API URL

        var filter = ''; // Filter string initialization

        // Event listener for filtering data
        this.on(this.app, 'flujoCaja:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string initialization

            for (var i = 0; i < object.length; i++) {
                // Construct filter string based on filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Construct filter string for date range
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // End date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing data in grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            $$('filterPopup').hide(); // Hide filter popup
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id); // Load data based on selected player
        });
    }
}

// FILE DOCUMENTED
